import { Badge, SpinnerLoader } from '@eppendorf/vnls-react-components';
import { ReportStatus } from '@eppendorf/vnls-reporting-service-utils';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import './report-status-badge.scss';

interface ReportStatusBadgeProps {
  status: ReportStatus;
  bordered?: boolean;
}

export function ReportStatusBadge({
  status,
  bordered = false,
}: ReportStatusBadgeProps): ReactElement {
  const { t } = useTranslation();

  switch (status) {
    case 'Ready':
      return (
        <Badge color="green" className="font-weight-medium" bordered={bordered}>
          {t('reportHub.status.ready')}
        </Badge>
      );
    case 'Pending':
      return (
        <Badge color="blue" className="font-weight-medium" bordered={bordered}>
          {t('reportHub.status.queued')}
        </Badge>
      );
    case 'Processing':
      return (
        <Badge color="blue" bordered={bordered}>
          <div className="flex flex__ai--center gap-s font-weight-medium">
            <SpinnerLoader className="report-status-badge-spinner" />
            {t('reportHub.status.generating')}
          </div>
        </Badge>
      );
    case 'Error':
      return (
        <Badge color="red" className="font-weight-medium" bordered={bordered}>
          {t('reportHub.status.error')}
        </Badge>
      );
    default:
      return <span>-</span>;
  }
}
